import {ILayout, ILayoutCSSClasses, ILayoutHTMLAttributes, ILayoutCSSVariables} from './LayoutModels'
import {DefaultLayoutConfig} from './DefaultLayoutConfig'

// The layout is fixed configuration, deliberately NOT read from localStorage: the old
// 'LayoutConfig-v2' key holds the pre-sidebar config shape (no `app` key), and loading it would
// render the app with no sidebar at all. Nothing in hrm writes a layout config any more.

export const getEmptyCssClasses = (): ILayoutCSSClasses => {
  return {
    header: [],
    headerContainer: [],
    headerMobile: [],
    headerMenu: [],
    aside: [],
    asideMenu: [],
    asideToggle: [],
    toolbar: [],
    toolbarContainer: [],
    content: [],
    contentContainer: [],
    footerContainer: [],
    sidebar: [],
    pageTitle: [],
    pageContainer: [],
  }
}

export const getEmptyHTMLAttributes = (): ILayoutHTMLAttributes => {
  return {
    asideMenu: new Map(),
    headerMobile: new Map(),
    headerMenu: new Map(),
    headerContainer: new Map(),
    pageTitle: new Map(),
  }
}

export const getEmptyCSSVariables = (): ILayoutCSSVariables => {
  return {
    body: new Map(),
  }
}

export class LayoutSetup {
  public static config: ILayout = DefaultLayoutConfig
  public static classes: ILayoutCSSClasses = getEmptyCssClasses()
  public static attributes: ILayoutHTMLAttributes = getEmptyHTMLAttributes()
  public static cssVariables: ILayoutCSSVariables = getEmptyCSSVariables()

  // Mark <body> as an app-layout page. The sidebar and header components add their own
  // data-kt-app-* attributes when they mount and remove them on unmount, so the auth pages
  // never inherit the sidebar offsets. Existing body classes (page-loading) are left alone.
  private static initBody(config: ILayout): void {
    document.body.setAttribute('id', 'kt_app_body')
    document.body.setAttribute('data-kt-app-layout', config.layoutType)
    document.body.setAttribute('data-kt-name', 'metronic')
    document.body.classList.add('app-default')
  }

  public static updatePartialConfig(fieldsToUpdate: Partial<ILayout>): ILayout {
    const updatedConfig = {...LayoutSetup.config, ...fieldsToUpdate}
    LayoutSetup.classes = getEmptyCssClasses()
    LayoutSetup.attributes = getEmptyHTMLAttributes()
    LayoutSetup.cssVariables = getEmptyCSSVariables()
    LayoutSetup.initBody(updatedConfig)
    LayoutSetup.config = updatedConfig
    return updatedConfig
  }

  public static bootstrap = (() => {
    LayoutSetup.updatePartialConfig(LayoutSetup.config)
  })()
}
